import React from "react";
import { Bell, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const PartnerHeader: React.FC = () => {
  // Em produção, viria do contexto de autenticação
  const companyData = {
    name: localStorage.getItem("partnerCompanyName") || "Empresa",
    cnpj: localStorage.getItem("partnerCNPJ") || ""
  };

  return (
    <header className="h-16 border-b border-gray-200 bg-white flex items-center justify-between px-6">
      <div className="flex items-center gap-4 flex-1">
        <div className="relative max-w-md w-full">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <Input
            type="search"
            placeholder="Buscar clientes, voos, check-ins..."
            className="pl-10 w-full"
          />
        </div>
      </div>

      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" className="relative">
          <Bell className="h-5 w-5" />
          <span className="absolute top-1 right-1 h-2 w-2 bg-red-500 rounded-full"></span>
        </Button>
        
        <div className="flex items-center gap-3">
          <div className="text-right">
            <p className="text-sm font-medium text-gray-900">{companyData.name}</p>
            <p className="text-xs text-gray-500">{companyData.cnpj}</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default PartnerHeader;
